// extracted by mini-css-extract-plugin
export default {"app":"App_app__GQ97N","content":"App_content__i-RuO"};